import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TalentSelection } from "../../components/project/TalentSelection";

const TalentSearch: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box>
			<Box px={{ xs: 2, sm: 4, md: 6 }} pt={3} pb={1}>
				<Typography variant="h4" sx={{ fontWeight: 500 }}>
					{t("talentSearch.title")}
				</Typography>
			</Box>
			<TalentSelection />
		</Box>
	);
};

export default TalentSearch;
